import { SOFTLINE_FEATURE_MODAL, ModalStore } from '@softline/ui-core';
import { EntityInputStrategy } from '@softline/ui-core/entity-input';
import {Entity, Store} from '@softline/core';
import {BehaviorSubject, first, firstValueFrom, lastValueFrom, Observable, take} from 'rxjs';
import {
  HardwareListeEntityInputDialogComponent
} from '../dialogs/hardware-liste-entity-input-dialog/hardware-liste-entity-input-dialog.component';
import {signal, TemplateRef} from '@angular/core';

export interface HardwareListeEntityInputParams {
  entities$:BehaviorSubject<Entity[]>
  filteredEntities$:Observable<Entity[]>
  highlightedIndex$: BehaviorSubject<number>
  selectedView$: BehaviorSubject<'filter' | 'results' | 'create' | 'edit'>
  input$: BehaviorSubject<string | null>
  entityInEditing$: BehaviorSubject<Entity | null | undefined>
  entityEditTemplate$: BehaviorSubject<TemplateRef<any>>
  entityCreateTemplate$: BehaviorSubject<TemplateRef<any>>
  entityResultTemplate$: BehaviorSubject<TemplateRef<any>>
}

export class HardwareListeEntityInputStrategy extends EntityInputStrategy<any> {

  loading = signal(false);

  constructor(
    private store: Store,
    private params: HardwareListeEntityInputParams
  ) {
    super();
  }

  override async open(input: string | null, options?: unknown): Promise<any> {
    console.log(this.params);
    const result = await this.openDialog();
    return result;
  }

  override async validate(input: string | null, options?: unknown): Promise<any> {
    console.log('validate: ', this.params);

    this.loading.set(true);
    const filteredEntities = await lastValueFrom<Entity[]>(this.params.filteredEntities$.pipe(first()));

    if (filteredEntities.length === 1) {
      this.loading.set(false);
      return filteredEntities[0];
    }
    
    const result = await this.openDialog();
    this.loading.set(false);
    return result;
  }

  override async cancel(): Promise<boolean> {
    return true;
  }

  private async openDialog(): Promise<any | null> {
    const result = await this.store.dispatch(
      SOFTLINE_FEATURE_MODAL,
      ModalStore.actions.open(),
      {
        id: 'SOFTLINE_HARDWARE_VERWALTUNG_ENTITY_INPUT',
        component: HardwareListeEntityInputDialogComponent,
        dismiss: true,
        data: {
          params: this.params
        }
      }
    );

    if (result === 'DISMISSED')
      return null;

    return result;
  }
}
